module.exports = __webpack_public_path__ + "static/media/couch2.1a6beab9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/floorPlan/couch2.svg
// module id = 1121
// module chunks = 38